define('responsive-gameday/utils/ui-log',['require','exports','module','app-console/app-console','GameDayCore/GDUtil/resources/GDConfig'],function(require,exports,module){
	var UILog = require('app-console/app-console'),
		GDConfig =  require('GameDayCore/GDUtil/resources/GDConfig');

	// Inherit log-level from GDCore
	return new UILog({ns : 'GDUI', level : GDConfig.log});
});
